export default "__VITE_ASSET__CQWSdwzp__"